'use client';

import { EvSalesValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface CalculatorInputsProps {
  values: EvSalesValues;
  onValuesChange: (field: keyof EvSalesValues, value: number | string) => void;
  translations: ToolsTranslations['evSales'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: CalculatorInputsProps) {
  const handleInputChange = (field: keyof EvSalesValues, value: string) => {
    const cleaned = value.replace(/\s/g, '');
    const numValue = parseFloat(cleaned);
    if (!isNaN(numValue) && numValue >= 0) {
      onValuesChange(field, numValue);
    }
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <label htmlFor="market-cap" className="block text-sm font-medium text-gray-700">{translations.marketCap}</label>
        <div className="relative">
          <input id="market-cap" type="text" value={values.marketCap.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('marketCap', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="total-debt" className="block text-sm font-medium text-gray-700">{translations.totalDebt}</label>
        <div className="relative">
          <input id="total-debt" type="text" value={values.totalDebt.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('totalDebt', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="cash" className="block text-sm font-medium text-gray-700">{translations.cash}</label>
        <div className="relative">
          <input id="cash" type="text" value={values.cash.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('cash', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="sales" className="block text-sm font-medium text-gray-700">{translations.sales}</label>
        <div className="relative">
          <input id="sales" type="text" value={values.sales.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('sales', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
    </div>
  );
}


